import React from 'react';
import { CommandCenterPage } from './pages/CommandCenterPage';
export function App() {
  return <CommandCenterPage data-id="element-0" />;
}